import { render, staticRenderFns } from "./QuestionRectSingle.vue?vue&type=template&id=57185d3a&scoped=true&"
import script from "./QuestionRectSingle.vue?vue&type=script&lang=js&"
export * from "./QuestionRectSingle.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRectSingle.vue?vue&type=style&index=0&id=57185d3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57185d3a",
  null
  
)

export default component.exports